<template>
	<core-modal
		:name="campaign.id + '-delete-modal'"
		class="omapi-modal delete-modal"
		:clickToClose="!isDeletingCampaign"
		:isConfirmation="true"
		:childRefs="$refs"
	>
		<modals-content>
			<form @submit.prevent="deleteCampaignHandler">
				<p>Are you sure you want to <strong>permanently</strong> delete the {{ campaign.name }} ({{ campaign.id }}) campaign? This will <strong>also delete any split tests</strong> connected to the deleted campaign.</p>

				<section class="buttons">
					<core-loading-button
						class="delete-campaign"
						color="blue"
						size="large"
						buttonType="submit"
						:loading="isDeletingCampaign"
						ref="toFocus"
					>
						Yes, I'm Sure
					</core-loading-button>
					<button
						class="omapi-button omapi-button__white omapi-button__large"
						@click.prevent="$modal.hide(campaign.id + '-delete-modal')"
						:disabled="isDeletingCampaign"
					>Cancel</button>
				</section>
			</form>
		</modals-content>
	</core-modal>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
const { mapActions } = createNamespacedHelpers('campaigns')

export default {
	props : {
		campaign : {
			type     : Object,
			required : true,
		},
	},
	data () {
		return {
			isDeletingCampaign : false,
		}
	},
	methods : {
		...mapActions([ 'deleteCampaign' ]),
		async deleteCampaignHandler () {
			const message = `The ${this.campaign.name} campaign was deleted successfully.`
			this.isDeletingCampaign = true
			await this.deleteCampaign(this.campaign)

			this.isDeletingCampaign = false
			this.$store.commit('campaigns/addAlert', {
				message,
				type : 'success',
			})
			this.$modal.hide(this.campaign.id + '-delete-modal')
		},
	},
}
</script>

<style lang="scss">
.delete-modal {

}
</style>
